import React from 'react';

const HERO_IMAGE = 'https://images.unsplash.com/photo-1662622008881-ea6d94c98e9d?w=800&q=80';
const TAGS = ['5 axes', 'AI Vision', 'PDF Export'];

/** Left editorial panel of the auth screen (desktop only). */
export const AuthHero = ({ language }) => (
  <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden items-center justify-center" data-testid="auth-hero">
    <div className="absolute inset-0 bg-gradient-to-br from-[var(--lux-obsidian)] via-[var(--lux-panel)] to-[var(--lux-ink)]" />
    <div
      className="absolute inset-0"
      style={{ backgroundImage: `url(${HERO_IMAGE})`, backgroundSize: 'cover', backgroundPosition: 'center', opacity: 0.12 }}
    />
    <div className="relative z-10 max-w-md px-12">
      <div className="flex items-center gap-3 mb-8">
        <img src="/logo.jpeg" alt="PrimeFace" className="w-12 h-12 rounded-xl object-cover border border-lux-gold/30" />
        <h1 className="font-display text-4xl text-white">PrimeFace</h1>
      </div>
      <p className="text-white/60 text-lg leading-relaxed">
        {language === 'fr'
          ? 'Votre coach IA personnel en optimisation esth\u00e9tique. Analyse, plan d\'action et suivi de progression.'
          : 'Your personal AI coach for aesthetic optimization. Analysis, action plan and progress tracking.'}
      </p>
      <div className="mt-12 flex gap-8">
        {TAGS.map(tag => (
          <span key={tag} className="text-[10px] uppercase tracking-[0.2em] text-lux-gold/70 border border-lux-gold/20 px-3 py-1 rounded-full">{tag}</span>
        ))}
      </div>
    </div>
  </div>
);
